import { useEffect, useState } from "react";
import { Building2, Users, UserCheck, HardHat, Wrench, Package, ShoppingBag } from "lucide-react";
import { useApi } from "@/lib/api";
import { Spinner } from "@/components/common";

const CARDS = [
  ["active_projects", "مشاريع مفعّلة", Building2],
  ["owners", "ملاك معتمدون", Users],
  ["pending_owners", "بانتظار الاعتماد", UserCheck],
  ["employees", "موظفون", HardHat],
  ["open_maintenance", "بلاغات صيانة مفتوحة", Wrench],
  ["open_orders", "طلبات متجر جارية", ShoppingBag],
  ["products", "منتجات", Package],
];

export default function AdminOverview() {
  const api = useApi();
  const [s, setS] = useState(null);
  useEffect(() => {
    api("get", "/admin/stats").then(setS).catch(() => {});
  }, [api]);
  if (!s) return <Spinner />;
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
      {CARDS.map(([k, l, Icon], i) => (
        <div key={k} className={`rounded-2xl p-6 fade-up ${i === 0 ? "bg-[#0F382C] text-white" : "bg-white border border-[#E5DEC9]"}`} style={{ animationDelay: `${i * 60}ms` }} data-testid={`stat-${k}`}>
          <Icon className={`h-6 w-6 ${i === 0 ? "text-[#C59B27]" : "text-[#0F382C]"}`} />
          <p className="mt-4 text-3xl font-extrabold">{s[k]}</p>
          <p className={`text-sm ${i === 0 ? "text-white/70" : "text-[#5C7067]"}`}>{l}</p>
        </div>
      ))}
    </div>
  );
}
